export default {
    allowedSalutations: {},
    salutation: null,
    first_name: '',
    last_name: '',
    email: '',
    language: '',
    current_password: '',
    password: '',
    password_confirmation: '',
    passwordConfirmed: false,
    currentPwordHidden: true,
    pwordHidden: true,
    pwordConfirmHidden: true,
    passwordValidated: false,
    passwordSubmitFailed: false,
    remember_me: false,
    accepted_terms: false,
    over_18: false,
    date_of_birth: '',
    callbackUrl: window.callbackUrl,
    go_to_smartcharts: window.go_to_smartcharts,
    hasUser: false, // Will trigger updating the user on refresh but not on every guard call
    affiliate: false
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Auth/state.js